// src/chains/chainConfig.js
/**
 * This file defines the standardized chain configuration format
 * that makes it easy to add new chains to the wallet.
 */

/**
 * Creates a standardized chain configuration object
 * @param {Object} config - Chain configuration
 * @returns {Object} - Standardized chain configuration
 */
export const createChainConfig = (config) => {
  // Default values
  const defaults = {
    supportsEIP1559: false,
    maxTokensToDisplay: 500,
    nativeTokenDecimals: 18,
  };

  // Validate required fields
  const requiredFields = [
    'key', 'chainId', 'name', 'rpcUrl', 'explorerUrl', 
    'nativeTokenSymbol', 'nativeTokenName'
  ];
  
  // Note: We removed 'aggregatorAddress' from required fields as it could be SushiSwap, KyberSwap or an address
  
  requiredFields.forEach(field => {
    if (!config[field]) {
      console.error(`Chain configuration missing required field: ${field}`);
    }
  });

  // Check for API configuration
  if (config.aggregatorAddress === 'SushiSwap') {
    if (!config.sushiswapConfig) {
      console.error('SushiSwap configuration missing');
    }
  } else if (!config.aggregatorAddress) {
    console.error('Chain configuration missing aggregatorAddress');
  }

  // Return merged configuration with defaults
  return {
    ...defaults,
    ...config,
    // Ensure nativeToken is properly formatted
    nativeToken: {
      symbol: config.nativeTokenSymbol || 'NATIVE',
      name: config.nativeTokenName || config.name,
      decimals: config.nativeTokenDecimals || 18,
      address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', // Standard placeholder for native tokens
      icon: config.nativeTokenIcon || null
    }
  };
};